'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unWatchEvents = exports.watchEvents = exports.unWatchEvent = exports.watchEvent = undefined;

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

var _constants = require('../constants');

var _populate = require('../utils/populate');

var _query = require('../utils/query');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var START = _constants.actionTypes.START,
    SET = _constants.actionTypes.SET,
    UNAUTHORIZED_ERROR = _constants.actionTypes.UNAUTHORIZED_ERROR;
var watchEvent = exports.watchEvent = function watchEvent(firebase, dispatch, options) {
  var queryId = options.queryId;
  var type = options.type,
      path = options.path,
      populates = options.populates,
      queryParams = options.queryParams,
      isQuery = options.isQuery,
      storeAs = options.storeAs;

  var watchPath = !storeAs ? path : path + '@' + storeAs;
  var counter = (0, _query.getWatcherCount)(firebase, type, watchPath, queryId);
  queryId = queryId || (0, _query.getQueryIdFromPath)(path, type);

  if (counter > 0) {
    if (queryId) {
      (0, _query.unsetWatcher)(firebase, dispatch, type, path, queryId);
    } else {
      return;
    }
  }

  (0, _query.setWatcher)(firebase, type, watchPath, queryId);

  if (type === 'first_child') {
    return firebase.database().ref().child(path).orderByKey().limitToFirst(1).once('value', function (snapshot) {
      if (snapshot.val() === null) {
        dispatch({
          type: _constants.actionTypes.NO_VALUE,
          timestamp: Date.now(),
          requesting: false,
          requested: true,
          path: storeAs || path
        });
      }
      return snapshot;
    }).catch(function (err) {
      dispatch({
        type: _constants.actionTypes.ERROR,
        payload: err
      });
      return Promise.reject(err);
    });
  }

  var query = firebase.database().ref().child(path);

  if (isQuery) {
    query = (0, _query.applyParamsToQuery)(queryParams, query);
  }

  var runQuery = function runQuery(q, e, p, params) {
    dispatch({
      type: START,
      timestamp: Date.now(),
      requesting: true,
      requested: false,
      path: storeAs || path
    });

    if (e === 'once') {
      return q.once('value').then(function (snapshot) {
        dispatch({
          type: SET,
          path: storeAs || path,
          data: snapshot.val(),
          ordered: (0, _query.orderedFromSnapshot)(snapshot)
        });
        return snapshot;
      }).catch(function (err) {
        dispatch({
          type: _constants.actionTypes.ERROR,
          payload: err
        });
        return Promise.reject(err);
      });
    }

    q.on(e, function (snapshot) {
      var data = e === 'child_removed' ? undefined : snapshot.val();
      var resultPath = storeAs || e === 'value' ? p : p + '/' + snapshot.key;
      var ordered = (0, _query.orderedFromSnapshot)(snapshot, e);

      if (!populates) {
        return dispatch({
          type: SET,
          path: storeAs || resultPath,
          ordered: ordered,
          data: data,
          timestamp: Date.now(),
          requesting: false,
          requested: true
        });
      }

      var dataKey = snapshot.key;
      (0, _populate.promisesForPopulate)(firebase, dataKey, data, populates).then(function (results) {
        (0, _forEach3.default)(results, function (result, path) {
          dispatch({
            type: SET,
            path: path,
            data: result,
            timestamp: Date.now(),
            requesting: false,
            requested: true
          });
        });
        dispatch({
          type: SET,
          path: storeAs || resultPath,
          ordered: ordered,
          data: data,
          timestamp: Date.now(),
          requesting: false,
          requested: true
        });
      });
    }, function (err) {
      dispatch({
        type: UNAUTHORIZED_ERROR,
        payload: err
      });
    });
  };

  return runQuery(query, type, path, queryParams);
};

var unWatchEvent = exports.unWatchEvent = function unWatchEvent(firebase, dispatch, _ref) {
  var type = _ref.type,
      path = _ref.path,
      storeAs = _ref.storeAs,
      queryId = _ref.queryId;

  var watchPath = !storeAs ? path : path + '@' + storeAs;
  (0, _query.unsetWatcher)(firebase, dispatch, type, watchPath, queryId);
};

var watchEvents = exports.watchEvents = function watchEvents(firebase, dispatch, events) {
  return events.forEach(function (event) {
    return watchEvent(firebase, dispatch, event);
  });
};

var unWatchEvents = exports.unWatchEvents = function unWatchEvents(firebase, dispatch, events) {
  return events.forEach(function (event) {
    return unWatchEvent(firebase, dispatch, event);
  });
};

exports.default = { watchEvents: watchEvents, unWatchEvents: unWatchEvents };


//////////////////
// WEBPACK FOOTER
// ../~/react-redux-firebase/es/actions/query.js
// module id = 566
// module chunks = 0